(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-display"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Helper: load script once
  function loadScriptOnce(src, globalCheck, cb) {
    if (globalCheck && (typeof globalCheck !== 'function' ? window[globalCheck] : globalCheck())) {
      return cb && cb();
    }
    // prevent duplicate tag insertion
    if (document.querySelector('script[data-src="'+src+'"]')) {
      // already loading — poll for globalCheck
      var poll = setInterval(function(){
        if (globalCheck && (typeof globalCheck !== 'function' ? window[globalCheck] : globalCheck())) {
          clearInterval(poll); cb && cb();
        }
      }, 50);
      return;
    }
    var s = document.createElement('script');
    s.setAttribute('data-src', src);
    s.src = src;
    s.async = false;
    s.onload = function(){ cb && cb(); };
    document.head.appendChild(s);
  }

  function loadCSSOnce(href) {
    if (document.querySelector('link[data-href="'+href+'"]')) return;
    var l = document.createElement('link');
    l.setAttribute('data-href', href);
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  // Queue all gallery instances on DOMContentLoaded
  var galleryQueue = window.__productGalleryQueue = window.__productGalleryQueue || [];

  document.addEventListener('DOMContentLoaded', function() {
    // For each product-gallery section on the page, register an init object
    document.querySelectorAll('.product-gallery[id^="product-gallery-"]').forEach(function(container){
      var id = container.id.replace('product-gallery-','');
      // Avoid duplicate registration
      if (galleryQueue.some(function(g){ return g.sectionId === id; })) return;
      galleryQueue.push({
        sectionId: id,
        container: container,
        thumbsSelector: container.querySelector('.thumbs-slider') ? '.thumbs-slider-' + id : null,
        mainImageSelector: container.querySelector('#mainImage-'+id) ? '#mainImage-'+id : null
      });
    });

    // If queue empty, nothing to do
    if (!galleryQueue.length) return;

    // Load jQuery if not present, then load Slick (only once)
    var ensureJq = function(cb){
      if (window.jQuery) return cb(window.jQuery);
      loadScriptOnce('https://code.jquery.com/jquery-3.6.0.min.js', function(){ return !!window.jQuery; }, function(){
        cb(window.jQuery);
      });
    };

    ensureJq(function($){
      // now ensure slick CSS + JS
      loadCSSOnce('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
      loadScriptOnce('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function(){ return !!$.fn.slick; }, function(){
        initAllGalleries($);
      });
    });
  });

  // Initialise all queued galleries scoped per container
  function initAllGalleries($) {
    var queue = window.__productGalleryQueue || [];
    queue.forEach(function(item){
      try {
        initSingleGallery($, item);
      } catch (e) {
        console.error('Gallery init error for section', item.sectionId, e);
      }
    });
  }

  function initSingleGallery($, item) {
    var sectionId = item.sectionId;
    var thumbsContainer = document.querySelector('.thumbs-slider-' + sectionId);
    var mainImgEl = document.querySelector('#mainImage-' + sectionId);

    if (!thumbsContainer || !mainImgEl) return;

    var $thumbs = $(thumbsContainer);
    var $imgs = $thumbs.find('img');

    // Only init slick if more than 6 original images and not already initialised
    if ($imgs.length > 5 && !$thumbs.hasClass('slick-initialized')) {
      $thumbs.slick({
        vertical: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev">↑</button>',
        nextArrow: '<button type="button" class="slick-next">↓</button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              vertical: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              prevArrow: '<button type="button" class="slick-prev">←</button>',
              nextArrow: '<button type="button" class="slick-next">→</button>',
            }
          }
        ]
      });
      // re-acquire images (Slick might clone nodes)
      $imgs = $thumbs.find('img');
    }

    // Delegate click on the thumbs container (works with Slick clones)
    $thumbs.off('click.productGallery' + sectionId).on('click.productGallery' + sectionId, 'img', function(e){
      e.preventDefault();
      var $this = $(this);
      var newSrc = $this.attr('data-large') || $this.attr('src');
      // Smooth fade swap
      var $main = $(mainImgEl);
      $main.stop(true, true).fadeOut(120, function(){
        $main.attr('src', newSrc).fadeIn(160);
      });
      // Toggle active classes inside this thumbs container only
      $thumbs.find('img').removeClass('active');
      $this.addClass('active');
      // If thumb is inside slick, ensure that slick moves to make active visible
      if ($thumbs.hasClass('slick-initialized')) {
        var idx = $this.closest('.slick-slide').data('slick-index');
        if (typeof idx !== 'undefined') $thumbs.slick('slickGoTo', idx);
      }
    });

    // ensure first thumb has active class
    $thumbs.find('img').removeClass('active');
    $thumbs.find('img').first().addClass('active');
  }

})();

  } catch(e) { console.error(e); }
})();
})();
